import { Section, Field } from "./Section";

export default function PersonalSection({ resume, setResume, open, onToggle }) {
  const update = (k, v) =>
    setResume((r) => ({ ...r, personal: { ...r.personal, [k]: v } }));
  const p = resume.personal;
  return (
    <Section id="personal" title="Personal details" open={open} onToggle={onToggle}>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Full name" testid="fullName">
          <input className="field-input" value={p.fullName} onChange={(e) => update("fullName", e.target.value)} placeholder="Jane Doe" data-testid="input-fullName" />
        </Field>
        <Field label="Title" testid="title">
          <input className="field-input" value={p.title} onChange={(e) => update("title", e.target.value)} placeholder="Senior Software Engineer" data-testid="input-title" />
        </Field>
        <Field label="Email" testid="email">
          <input className="field-input" type="email" value={p.email} onChange={(e) => update("email", e.target.value)} placeholder="jane@example.com" data-testid="input-email" />
        </Field>
        <Field label="Phone" testid="phone">
          <input className="field-input" value={p.phone} onChange={(e) => update("phone", e.target.value)} placeholder="+1 555 000 0000" data-testid="input-phone" />
        </Field>
        <Field label="Location" testid="location">
          <input className="field-input" value={p.location} onChange={(e) => update("location", e.target.value)} placeholder="City, Country" data-testid="input-location" />
        </Field>
        <Field label="Website" testid="website">
          <input className="field-input" value={p.website} onChange={(e) => update("website", e.target.value)} placeholder="janedoe.com" data-testid="input-website" />
        </Field>
        <Field label="LinkedIn" testid="linkedin">
          <input className="field-input" value={p.linkedin} onChange={(e) => update("linkedin", e.target.value)} placeholder="linkedin.com/in/janedoe" data-testid="input-linkedin" />
        </Field>
        <Field label="GitHub" testid="github">
          <input className="field-input" value={p.github} onChange={(e) => update("github", e.target.value)} placeholder="github.com/janedoe" data-testid="input-github" />
        </Field>
      </div>
    </Section>
  );
}
